<template>
    <div class="wrap">
        <div class="d-flex">
            <div class="mr-auto">
                <button class="btn btn-secondary" @click="refresh"><i class="fas fa-sync-alt"></i></button>
                <slot name="buttons"></slot>
            </div>
            <div class="align-self-end">
                <input-debounced
                        v-model="search"
                        :clearable="true"
                        :autofocus="true"
                        placeholder="Search"
                        class="search-bar w-300 mb-2"
                ></input-debounced>
            </div>
        </div>
        <base-table
                :base-url="urlWithFilters"
                ref="baseTable"
                @load-success="onLoadSuccess"
                @refresh="onRefresh"
                :current-page="currentPage"
                v-loading="isRefreshing"
                element-loading-spinner="el-icon-loading"
        >
            <template v-slot>
                <el-table
                        :data="items"
                        stripe
                        class="w-100"
                >
                    <el-table-column
                            prop="model.id"
                            label="Id"
                            min-width="80"
                    ></el-table-column>
                    <el-table-column
                            prop="model.name"
                            label="Name"
                            min-width="150"
                    ></el-table-column>
                    <el-table-column
                            prop="model.message"
                            label="Message"
                            :formatter="formatMessage"
                            min-width="350"
                    ></el-table-column>
                    <el-table-column
                            prop="model.min_interval"
                            label="Min interval"
                            min-width="100"
                            :formatter="formatMinInterval"
                    ></el-table-column>
                    <el-table-column
                            prop="model.max_messages"
                            label="Send limit"
                            min-width="100"
                            :formatter="formatMaxMessages"
                    ></el-table-column>
                    <el-table-column
                            prop="model.created_at"
                            label="Created at"
                            min-width="120"
                            :formatter="formatDate"
                    ></el-table-column>
                    <el-table-column
                            label="Actions"
                            v-slot="{row}"
                    >
                        <actions-column :row="row" @edit="onEdit" @delete="onDelete"></actions-column>
                    </el-table-column>
                </el-table>
            </template>
        </base-table>
        <el-pagination
                layout="prev, pager, next"
                :total="total"
                :current-page.sync="currentPage"
                :page-size="pageSize"
                class="text-right"
        ></el-pagination>
    </div>
</template>

<script>
  import TableWithPagination from '../table-with-pagination';
  import {addQueryParams} from '../../libs/url';
  import ActionsColumn from './actions-column';
  import {strLimit} from "../../helpers";

  export default {
    extends: TableWithPagination,

    components: {
      ActionsColumn
    },

    data() {
      return {
        search: null,
        filters: {},
      };
    },
    computed: {
      /**
       * @return {string}
       */
      urlWithFilters() {
        return addQueryParams(this.url, this.filters);
      },
    },
    watch: {
      search: function (value) {
        if (value) {
          this.filters = _.assign({}, this.filters, {search: value});
        } else {
          this.filters = _.omit(this.filters, ['search']);
        }
      },
    },
    methods: {
      /**
       * @param {object} row
       * @param {object} col
       * @param {string} datetime
       */
      formatDate(row, col, {datetime}) {
        return moment(datetime).format(config('format.moment.short.datetime'));
      },

      /**
       * @param {object} row
       * @param {object} col
       * @param {string} value
       * @return {string}
       */
      formatMessage(row, col, value) {
        return strLimit(String(value), 50);
      },

      /**
       * @param {object} row
       * @param {object} col
       * @param {string} value
       * @return {string}
       */
      formatMinInterval(row, col, value) {
        if (!_.isFinite(value)) {
          return '-';
        }

        const days = _.floor(moment.duration(value, 'seconds').asDays());

        return `${days} day(s)`;
      },

      /**
       * @param {object} row
       * @param {object} col
       * @param {string} value
       * @return {string}
       */
      formatMaxMessages(row, col, value) {
        return value ? value : '-';
      },

      /**
       * @return {undefined}
       */
      refresh() {
        this.$refs.baseTable.refresh();
      },

      /**
       * @param {string} url
       * @event show-add-campaign-template-dialog
       */
      onEdit({url}) {
        eventBus.$emit('show-add-campaign-template-dialog', url);
      },
      /**
       * @param {string} url
       */
      onDelete({url}) {
        axios.post(url, {_method: 'DELETE'})
          .then(({data: {message}}) => {
            _.isString(message) && this.$message.success(message);
            this.refresh();
          })
          .catch((err) => {
            const message = _.get(err, 'response.data.message');
            _.isString(message) && this.$message.error(message);
          });
      }
    }
  }
</script>

<style scoped>

</style>
